import { Box, InputBase, Stack } from "@mui/material";
import { styled } from "@mui/material/styles";

export const SearchBox = styled("div")(({ theme }) => ({
  alignItems: "center",
  backgroundColor: theme.customColors.backgroundSecondary,
  borderRadius: "0.5rem",
  display: "flex",
  flex: 1,
  gap: "0.5rem",
  height: "2.5rem",
  minWidth: 0,
  padding: "0 0.75rem"
}));

export const SearchInput = styled(InputBase)(({ theme }) => ({
  "& .MuiInputBase-input::placeholder": {
    color: theme.customColors.backgroundDisabled,
    opacity: 1
  },
  color: theme.customColors.textInput,
  flex: 1
}));

export const SelectorPanel = styled(Box)(({ theme }) => ({
  border: `1px solid ${theme.customColors.border}`,
  borderRadius: "1rem",
  display: "flex",
  flexDirection: "column",
  gap: "1rem",
  marginTop: "0.75rem",
  padding: "1rem"
}));

export const PanelHeader = styled("button")(({ theme }) => ({
  alignItems: "center",
  background: "none",
  border: "none",
  color: theme.customColors.textPrimary,
  cursor: "pointer",
  display: "flex",
  justifyContent: "space-between",
  padding: 0,
  width: "100%"
}));

export const ResultsList = styled(Stack)(() => ({
  gap: "0.5rem",
  maxHeight: "22rem",
  overflowY: "auto",
  paddingRight: "0.25rem"
}));

export const CourseRow = styled("label")<{ $selected: boolean }>(({ $selected, theme }) => ({
  alignItems: "center",
  background: theme.customColors.backgroundCard,
  border: `1px solid ${$selected ? theme.customColors.borderAccent : "transparent"}`,
  borderRadius: "0.5rem",
  cursor: "pointer",
  display: "flex",
  gap: "0.75rem",
  padding: "0.75rem 1rem"
}));

export const RowSeparator = styled("span")(({ theme }) => ({
  alignSelf: "stretch",
  borderLeft: `1px solid ${theme.customColors.border}`
}));

export const TypeChip = styled("span")(({ theme }) => ({
  background: theme.customColors.backgroundSecondaryAlternative,
  border: `1px solid ${theme.customColors.backgroundAccent}`,
  borderRadius: "0.25rem",
  color: theme.customColors.textTag,
  flexShrink: 0,
  fontSize: "0.75rem",
  fontWeight: 600,
  marginLeft: "auto",
  padding: "0.25rem 0.5rem",
  textTransform: "capitalize",
  whiteSpace: "nowrap"
}));
